import { ActionMenuItem } from '@frontapp/ui-kit';
import copy from 'copy-to-clipboard';
import { useNotifications } from 'reapop';

type Props = {
  title: string;
  value: string;
  isId?: boolean;
};

export default function CopyActionMenuItem({ title, value, isId }: Props) {
  const { notify } = useNotifications();

  function handleCopy(value: string) {
    copy(value);
    notify(`Value "${value}" copied to clipboard!`);
  }

  return (
    <ActionMenuItem iconName="Copy" onClick={() => handleCopy(value)}>
      {`${title}: ${isId ? '#' : ''}${value}`}
    </ActionMenuItem>
  );
}

CopyActionMenuItem.displayName = 'Custom';
